import { useEffect } from "react";
import useUrlParams from "../customHooks/useUrlParams";
import { GetCustCompSubName } from "../queries/queries";
import { useLazyQuery } from "@apollo/client";
import { nodeVar } from "../utils/commonQueryTypes";

interface nodeData {
  node: {
    name: string;
  };
}

const HeaderName = () => {
  const { company_id, customer_id, sub_id } = useUrlParams();


  const [GetName, { data }] = useLazyQuery<nodeData, nodeVar>(
    GetCustCompSubName
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
    
        if ((customer_id || company_id || sub_id)) {
          GetName({
            variables: {
              id: sub_id ? sub_id : company_id ? company_id : customer_id!,
            },
          });
        }
      } catch (err) {
        console.error((err as Error).message);
      }
    };
    fetchData();
  }, [GetName, customer_id, company_id, sub_id]);

  return (
    <>{data && (customer_id || company_id || sub_id) ? data.node.name : null}</>
  );
};

export default HeaderName;
